import React from "react";

import { IndexedCardInfo } from "@akj-dev/shared-components";
import { Checkbox, FormControlLabel } from "@mui/material";

interface LabelSIMProps {
  cardIndex: string;
  labelSIM: boolean;
  onLabelSIMChange: () => void;
}

export const LabelSIM = ({
  cardIndex,
  labelSIM,
  onLabelSIMChange,
}: LabelSIMProps) => (
  <IndexedCardInfo index={cardIndex} title="Label SIM">
    <FormControlLabel
      control={
        <Checkbox
          color="secondary"
          checked={labelSIM}
          onChange={onLabelSIMChange}
          name="labelSIM"
        />
      }
      label="Label SIM"
    />
  </IndexedCardInfo>
);
